/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkActionResultDtoOfString,
  CreateInitialAdminUserDto,
  DatabaseBackupResult,
  DatabaseChangeJobInfoDto,
  EmailSettingsEditDto,
  InstallationConfigDto,
  UpdateConnectionStringsRequestDto,
  UpdateSiteNameRequestDto,
} from '../models/index';
import {
    BulkActionResultDtoOfStringFromJSON,
    BulkActionResultDtoOfStringToJSON,
    CreateInitialAdminUserDtoFromJSON,
    CreateInitialAdminUserDtoToJSON,
    DatabaseBackupResultFromJSON,
    DatabaseBackupResultToJSON,
    DatabaseChangeJobInfoDtoFromJSON,
    DatabaseChangeJobInfoDtoToJSON,
    EmailSettingsEditDtoFromJSON,
    EmailSettingsEditDtoToJSON,
    InstallationConfigDtoFromJSON,
    InstallationConfigDtoToJSON,
    UpdateConnectionStringsRequestDtoFromJSON,
    UpdateConnectionStringsRequestDtoToJSON,
    UpdateSiteNameRequestDtoFromJSON,
    UpdateSiteNameRequestDtoToJSON,
} from '../models/index';

export interface CreateAdminUserRequest {
    createInitialAdminUserDto?: CreateInitialAdminUserDto;
}

export interface UpdateConnectionStringsRequest {
    updateConnectionStringsRequestDto?: UpdateConnectionStringsRequestDto;
}

export interface UpdateEmailSettingsRequest {
    emailSettingsEditDto?: EmailSettingsEditDto;
}

export interface UpdateSiteNameRequest {
    updateSiteNameRequestDto?: UpdateSiteNameRequestDto;
}

/**
 * 
 */
export class InstallApi extends runtime.BaseAPI {

    /**
     */
    async createAdminUserRaw(requestParameters: CreateAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/installation-configuration/admin-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInitialAdminUserDtoToJSON(requestParameters.createInitialAdminUserDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createAdminUser(requestParameters: CreateAdminUserRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createAdminUserRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async createBackupRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseBackupResult>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/installation-configuration/database/backups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseBackupResultFromJSON));
    }

    /**
     */
    async createBackup(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createBackupRaw(initOverrides);
        return this.configuration.handleFunction<Array<DatabaseBackupResult>>(response, errorHandlers);
    }

    /**
     */
    async deleteBackupFilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkActionResultDtoOfString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/installation-configuration/database/backups`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => BulkActionResultDtoOfStringFromJSON(jsonValue));
    }

    /**
     */
    async deleteBackupFiles(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteBackupFilesRaw(initOverrides);
        return this.configuration.handleFunction<BulkActionResultDtoOfString>(response, errorHandlers);
    }

    /**
     */
    async getBackupFilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/installation-configuration/database/backups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getBackupFiles(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getBackupFilesRaw(initOverrides);
        return this.configuration.handleFunction<Array<string>>(response, errorHandlers);
    }

    /**
     */
    async getInstallationConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallationConfigDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/installation-configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => InstallationConfigDtoFromJSON(jsonValue));
    }

    /**
     */
    async getInstallationConfig(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getInstallationConfigRaw(initOverrides);
        return this.configuration.handleFunction<InstallationConfigDto>(response, errorHandlers);
    }

    /**
     */
    async getUpdateConnectionStringsStateAsyncRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseChangeJobInfoDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/installation-configuration/database/state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseChangeJobInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getUpdateConnectionStringsStateAsync(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getUpdateConnectionStringsStateAsyncRaw(initOverrides);
        return this.configuration.handleFunction<DatabaseChangeJobInfoDto>(response, errorHandlers);
    }

    /**
     */
    async updateConnectionStringsRaw(requestParameters: UpdateConnectionStringsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/installation-configuration/database`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConnectionStringsRequestDtoToJSON(requestParameters.updateConnectionStringsRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateConnectionStrings(requestParameters: UpdateConnectionStringsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateConnectionStringsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async updateEmailSettingsRaw(requestParameters: UpdateEmailSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/installation-configuration/email-settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmailSettingsEditDtoToJSON(requestParameters.emailSettingsEditDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateEmailSettings(requestParameters: UpdateEmailSettingsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateEmailSettingsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async updateSiteNameRaw(requestParameters: UpdateSiteNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/installation-configuration/site-name`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSiteNameRequestDtoToJSON(requestParameters.updateSiteNameRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateSiteName(requestParameters: UpdateSiteNameRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateSiteNameRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
